/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/conponents/ProductDetailPriceDescModal/index.tsx
 * @Description:
 */
import { Modal, Table } from 'antd';
import styles from './index.module.scss';
import { QuoteMode } from 'libs/enums';
import { cls } from 'reactutils';

const ProductDetailPriceDescModal = ({ title, visible, onClose, skuForPriceCalculate }: any) => {
  const netPriceSourceInformation =
    skuForPriceCalculate?.agreementPriceForm?.netPriceSourceInformation;
  const equationWithNetPrice = skuForPriceCalculate?.agreementPriceForm?.equationWithNetPrice;
  const equationWithNetPriceValue =
    skuForPriceCalculate?.agreementPriceForm?.equationWithNetPriceValue;
  const agreementPrice =
    skuForPriceCalculate.quoteMode === QuoteMode.WITHOUT_TAX_TYPE
      ? skuForPriceCalculate.agreementPriceWithoutTax
      : skuForPriceCalculate.agreementPriceWithTax;
  const renderinstruction = skuForPriceCalculate?.agreementPriceForm?.addPriceRuleHeads.map(
    (label, index) => {
      return {
        dataIndex: index,
        title: label,
        width: '150px',
        align: 'center',
      };
    },
  );
  const tabledata = skuForPriceCalculate?.agreementPriceForm?.addPriceRuleRows.map((row) => {
    const obj = {};
    row.forEach((val, index) => {
      obj[index] = val;
    });
    return obj;
  });
  return (
    <Modal
      visible={visible}
      title={title || '查看规则'}
      footer={null}
      width="70%"
      style={{ height: '530px' }}
      onCancel={onClose}
    >
      <div>
        {skuForPriceCalculate && (
          <div className={styles.product_detail_price_desc_modal_content}>
            <div className={styles.price_desc_modal_row}>
              <div className={styles.price_desc_modal_label}>报价类型：</div>
              <div className={styles.price_desc_modal_txt}>
                {skuForPriceCalculate.quoteMode === QuoteMode.WITHOUT_TAX_TYPE
                  ? '除税价'
                  : '含税价'}
              </div>
            </div>
            {netPriceSourceInformation && (
              <>
                {netPriceSourceInformation.netPriceSource === 1 && (
                  <div className={styles.price_desc_modal_row}>
                    <span className={styles.price_desc_modal_label}>信息价：</span>
                    <span className={styles.price_desc_modal_txt}>
                      {netPriceSourceInformation.attributeList.map((item, index) => (
                        <span key={index} className={styles.price_desc_modal_txt_item}>
                          {item.categoryAttributeName}： {item.categoryAttributeValue}
                        </span>
                      ))}
                      <span className={styles.price_desc_modal_txt_item}>
                        价格：
                        <span className={styles.price_desc_modal_txt_item_price}>
                          {netPriceSourceInformation.price}
                        </span>
                        {netPriceSourceInformation.suffix}
                      </span>
                      <span className={styles.price_desc_modal_txt_item}>
                        来源：{netPriceSourceInformation.netPriceSourceString}
                      </span>
                    </span>
                  </div>
                )}
                {netPriceSourceInformation.netPriceSource === 2 && (
                  <div className={styles.price_desc_modal_row}>
                    <span className={styles.price_desc_modal_label}>网价：</span>
                    <span className={styles.price_desc_modal_txt_item}>
                      {netPriceSourceInformation.detail.map((item, index) => (
                        <div key={index}>
                          {item.map((v, i) => (
                            <span key={i}>
                              {v.categoryAttributeValueSysNo == '12345' ? (
                                <span className={styles.price_desc_modal_tag}>
                                  {v.categoryAttributeValue}
                                </span>
                              ) : v.categoryAttributeValue ? (
                                <span className={styles.price_desc_modal_txt_item}>
                                  {v.categoryAttributeName}： {v.categoryAttributeValue}
                                </span>
                              ) : (
                                ''
                              )}
                            </span>
                          ))}
                        </div>
                      ))}
                    </span>
                  </div>
                )}
                {netPriceSourceInformation.netPriceSource === 3 && (
                  <div className={styles.price_desc_modal_row}>
                    <span className={styles.price_desc_modal_label}>基础价：</span>
                    <span className={styles.price_desc_modal_txt}>
                      {netPriceSourceInformation.attributeList.map((item, index) => (
                        <span key={index} className={styles.price_desc_modal_txt_item}>
                          {item.categoryAttributeName}： {item.categoryAttributeValue}
                        </span>
                      ))}
                      <span className={styles.price_desc_modal_txt_item}>
                        {netPriceSourceInformation.prefix}：
                        <span className={styles.price_desc_modal_txt_item_price}>
                          {netPriceSourceInformation.price}
                        </span>
                        {netPriceSourceInformation.suffix}
                      </span>
                      <span className={styles.price_desc_modal_txt_item}>
                        来源：{netPriceSourceInformation.netPriceSourceString}
                      </span>
                    </span>
                  </div>
                )}
              </>
            )}
            <div>
              <span className={styles.price_desc_modal_label}>加价规则：</span>
              <Table
                pagination={false}
                columns={renderinstruction}
                dataSource={tabledata}
                bordered
              />
            </div>
            <div className={cls(styles.price_desc_modal_row, styles.price_desc_modal_row_equation)}>
              <span className={styles.price_desc_modal_label}>计算：</span>
              <div className={styles.price_equation_wrap}>
                <span>
                  {skuForPriceCalculate.quoteMode === QuoteMode.WITHOUT_TAX_TYPE
                    ? '除税单价'
                    : '含税单价'}
                </span>
                <div>
                  <div className={styles.price_equation_right_block}>= {equationWithNetPrice}</div>
                  <div className={styles.price_equation_right_block}>
                    = {equationWithNetPriceValue}
                  </div>
                  {agreementPrice && (
                    <div className={styles.price_equation_right_block}>= {agreementPrice}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ProductDetailPriceDescModal;
